module.exports = __webpack_public_path__ + "img/news3-4.0f6d673a.png";